/* eslint-disable */
import { api } from '@/services';

export default {
  async update(context, payload) {
    const { _id } = payload;
    return api.put(`/agendador/relatorioexcel/${_id}`, payload);
  },
  async salvar({ dispatch }, payload) {
    if (payload._id) {
      return dispatch('update', payload);
    }
    return api.post('/agendador/relatorioexcel/', {
        ...payload,
    });
  },
  async fetchRelatorios(context, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    /* eslint-disable */
    for (const key of keys) {
      if (payload[key]) {
        if (key === 'dias' || key === 'horarios') {
          if (payload[key].length > 0) {
            params.append(key, payload[key]);  
          }
        } else {
          params.append(key, payload[key]);
        }
      }
    }
    context.dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/agendador/relatorioexcel', { params })
      .then((response) => response.data);
    context.commit('SET_RELATORIOS', response.registros.data);
    context.commit('paginacao/SET_PAGINADOR', response, { root: true });
    context.dispatch('toggleLoading', false, { root: true });
  },
  async deletarRelatorio(context, id) {
    return api.delete(`/agendador/relatorioexcel/${id}`);
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
};
